import { createFileRoute } from "@tanstack/react-router";
import { CalendarDays } from "lucide-react";
import { EconomicCalendar } from "@/components/site/EconomicCalendar";

export const Route = createFileRoute("/_authenticated/dashboard/calendar")({
  head: () => ({
    meta: [
      { title: "Economic Calendar | XAU Pro Academy" },
      { name: "description", content: "High-impact USD economic events for the week ahead, plan your gold trading sessions around the data." },
    ],
  }),
  component: CalendarPage,
});

function CalendarPage() {
  return (
    <div className="container mx-auto max-w-5xl px-4 py-10 md:py-14">
      <div className="space-y-2">
        <div className="inline-flex items-center gap-2 rounded-full border border-gold/30 bg-gold-muted px-3 py-1 text-xs font-semibold uppercase tracking-wider text-gold">
          <CalendarDays className="h-3 w-3" /> Market Events
        </div>
        <h1 className="font-display text-3xl font-bold md:text-4xl">
          Economic <span className="text-gradient-gold">Calendar</span>
        </h1>
        <p className="max-w-2xl text-muted-foreground">
          High-impact USD events that move gold. All times in UTC, plan your sessions and avoid
          surprise volatility.
        </p>
      </div>

      <EconomicCalendar />
    </div>
  );
}
